/* eslint-disable max-lines */
import React from 'react';
import IcUpdateStock from '../components/icons/IcUpdateStock';
import IconAktivasiManual from '../components/icons/IconAkativasiManual';
import IconAreaManagement from '../components/icons/IconAreaManagement';
import IconAturHET from '../components/icons/IconAturHET';
import IconAudit from '../components/icons/IconAudit';
import IconLogSyns from '../components/icons/IconLogSyns';
import IconMerchantNoOnboard from '../components/icons/IconMerchantNoOnboard';
import IconMyptmActivation from '../components/icons/IconMyptmActivation';
import IconNotification from '../components/icons/IconNotification';
import IconPermission from '../components/icons/IconPermission';
import IconRegistrasiPangkalan from '../components/icons/IconRegistrasiPangkalan';
import IconRole from '../components/icons/IconRole';
import IconSettingBusinessType from '../components/icons/IconSettingBusinessType';
import IconSettingFaq from '../components/icons/IconSettingFaq';
import IconSubMerchantActivation from '../components/icons/IconSubMerchantActivation';
import IconTerm from '../components/icons/IconTerm';
import IconUser from '../components/icons/IconUser';
import IconVerification from '../components/icons/IconVerification';
import IconSettingMerchant from '../components/icons/IconsettingMerchant';
import pages from '../pages';
import styles from './routeBuilder.scoped.css';
import IconLpgSync from '../components/icons/IconLpgSync';
import IconLpgIn from '../components/icons/IconLpgIn';
import IconUnblock from '../components/icons/IconUnblock';
import IconUserExchange from '../components/icons/IconUserExchange';
import IconSettingFeatureMerchantFilled from '../components/icons/IconSettingFeatureMerchantFilled';
import IconInformasiBesaranSubsidi from '../components/icons/IconInformasiBesaranSubsidi';

export const router = [
  {
    serialNumber: 1,
    path: '/merchant/registrasi-pangkalan',
    icon: <IconRegistrasiPangkalan style={{ background: '#0f6eb5' }} />,
    menu: 'merchant-management',
    elements: [
      {
        path: '/merchant/registrasi-pangkalan/registrasi-sekaligus',
        element: <pages.RegistrasiSekaligusMerchant />,
        disabled: true,
      },
      {
        path: '/merchant/registrasi-pangkalan',
        element: <pages.RegistrasiPangkalan />,
      },
      {
        path: '/merchant/registrasi-pangkalan/:id/:type',
        element: <pages.DetailRegistrasiMerchant />,
      },
    ],
  },
  {
    serialNumber: 2,
    path: '/merchant/sinkronisasi-merchant',
    icon: <IconLogSyns />,
    menu: 'merchant-management',
    elements: [
      {
        path: '/merchant/sinkronisasi-merchant',
        element: <pages.SinkronisasiMerchant />,
      },
      {
        path: '/merchant/sinkronisasi-merchant/:id',
        element: <pages.DetailSinkronisasiMerchant />,
      },
    ],
  },
  {
    serialNumber: 3,
    path: '/merchant/verifikasi-data-merchant',
    icon: <IconVerification />,
    menu: 'merchant-management',
    elements: [
      {
        path: '/merchant/verifikasi-data-merchant',
        element: <pages.VerificationRegistrationMerchant />,
      },
      {
        path: '/merchant/detail-verifikasi-data-merchant',
        element: <pages.DetailVerfication />,
      },
    ],
  },
  {
    serialNumber: 4,
    path: '/merchant/setting-data-merchant',
    icon: <IconSettingMerchant />,
    menu: 'merchant-management',
    elements: [
      {
        path: '/merchant/setting-data-merchant',
        element: <pages.SettingMerchant />,
      },
      {
        path: '/merchant/setting-data-merchant/agent-history/:id',
        element: <pages.AgenHistory />,
      },
      {
        path: '/merchant/setting-data-merchant/detail/:id',
        element: <pages.DetailSetting />,
      },
      {
        path: '/merchant/setting-data-merchant/edit/:id',
        element: <pages.EditMerchant />,
        disabled: true,
      },
      {
        path: '/merchant/setting-data-merchant-update/:id',
        element: <pages.EditMerchant />,
      },
    ],
  },
  {
    serialNumber: 5,
    path: '/merchant/merchant-not-onboarding',
    icon: <IconMerchantNoOnboard />,
    menu: 'merchant-management',
    elements: [
      {
        path: '/merchant/merchant-not-onboarding',
        element: <pages.MerchantNotOnboarding />,
      },
    ],
  },
  {
    serialNumber: 6,
    path: '/merchant/aktivasi-mypertamina',
    icon: <IconMyptmActivation />,
    menu: 'merchant-management',
    elements: [
      {
        path: '/merchant/aktivasi-mypertamina',
        element: <pages.MyPertaminaActivation />,
      },
      {
        path: '/merchant/aktivasi-mypertamina/detail/:id',
        element: <pages.MyPertaminaActivationDetail />,
      },
      {
        path: '/merchant/aktivasi-mypertamina/bulk',
        element: <pages.MyPertaminaActivationBulk />,
      },
    ],
  },
  {
    serialNumber: 7,
    path: '/merchant/aktivasi-pencatatan-manual',
    icon: <IconAktivasiManual />,
    menu: 'merchant-management',
    elements: [
      {
        path: '/merchant/aktivasi-pencatatan-manual',
        element: <pages.AktivasiPencatatanManual />,
      },
    ],
  },
  {
    serialNumber: 8,
    path: '/merchant/update-stock-merchant',
    icon: <IcUpdateStock />,
    menu: 'merchant-management',
    elements: [
      {
        path: '/merchant/update-stock-merchant',
        element: <pages.UpdateStockMerchant />,
      },
      {
        path: '/merchant/update-stock-merchant/upload',
        element: <pages.UploadStockMerchant />,
      },
    ],
  },
  {
    serialNumber: 9,
    path: '/merchant/update-gr-merchant',
    icon: <IconLpgSync />,
    menu: 'merchant-management',
    elements: [
      {
        path: '/merchant/update-gr-merchant',
        element: <pages.UpdateGRMerchant />,
      },
    ],
  },
  {
    path: '/customer-setting',
    icon: <IconUserExchange />,
    menu: 'customer-setting',
    elements: [
      {
        path: '/customer-setting',
        element: <pages.NikManagement />,
      },
      {
        path: '/customer-setting/detail/:id',
        element: <pages.DetailCustomer />,
      },
      {
        path: '/customer-setting/setting-reason-block-id',
        element: <pages.SettingReasonBlockId />,
      },
    ],
  },
  {
    serialNumber: 1,
    path: '/province-transaction-restriction',
    icon: <IconUserExchange />,
    menu: 'customer-setting',
    elements: [
      {
        path: '/province-transaction-restriction',
        element: <pages.ProvinceTransactionRestriction />,
      },
      {
        path: '/province-transaction-restriction/detail/:id',
        element: <pages.ProvinceTransactionRestrictionDetail />,
      },
    ],
  },
  {
    path: '/submission-unblock',
    icon: <IconUnblock />,
    menu: 'customer-setting',
    elements: [
      {
        path: '/submission-unblock',
        element: <pages.CustomerSubmissionUnblock />,
      },
      {
        path: '/submission-unblock/detail/:id',
        element: <pages.CustomerSubmissionUnblockDetail />,
      },
    ]
  },
  {
    path: '/price',
    icon: <IconAturHET />,
    menu: 'price',
    elements: [
      {
        path: '/price',
        element: <pages.SettingHarga />,
      },
      {
        path: '/price/set',
        element: <pages.FormSettingHarga />,
      },
      {
        path: '/price/set/subpangkalan',
        element: <pages.FormSettingHargaSubPangkalan />,
      },
      {
        path: '/price/setting-sekaligus',
        element: <pages.SettingHargaSekaligus />,
      },
      {
        path: '/price/setting-sekaligus/subpangkalan',
        element: <pages.SettingHargaSekaligusSubPangkalan />,
      },
    ],
  },
  {
    path: '/subsidy-info',
    icon: <IconInformasiBesaranSubsidi />,
    menu: 'subsidy-info',
    serialNumber: 1,
    elements: [
      {
        path: '/subsidy-info',
        element: <pages.InformasiBesaranSubsidi />,
      },
    ],
  },
  {
    path: '/faq',
    icon: <IconSettingFaq />,
    menu: 'setting-map',
    serialNumber: 2,
    elements: [
      {
        path: '/faq',
        element: <pages.Faq />,
      },
      {
        path: '/faq/set',
        element: <pages.CreateFaq />,
      },
      {
        path: '/faq/edit',
        element: <pages.UpdateFaq />,
      },
      {
        path: '/faq/editSubpangkalan',
        element: <pages.UpdateFaqSubpangkalan />,
      },
    ],
  },
  {
    path: '/term-condition',
    icon: <IconTerm />,
    menu: 'setting-map',
    serialNumber: 1,
    elements: [
      {
        path: '/term-condition',
        element: <pages.TermCondition />,
      },
      {
        path: '/term-condition/preview/:type',
        element: <pages.TermConditionPreview />,
      },
      {
        path: '/term-condition/update',
        element: <pages.TermConditionUpdate />,
      },
    ],
  },
  {
    path: '/gigr-activation',
    icon: <IconLpgIn />,
    menu: 'setting-map',
    serialNumber: 1,
    elements: [
      {
        path: '/gigr-activation',
        element: <pages.GIGRActivation />,
      },
      {
        path: '/gigr-activation/activation-by-merchant',
        element: <pages.ActivationByMerchant />,
      },
      {
        path: '/gigr-activation/activation-bulk',
        element: <pages.ActivationMerchantBulk />,
      },
    ],
  },
  {
    path: '/notification',
    icon: <IconNotification />,
    menu: 'setting-map',
    serialNumber: 3,
    elements: [
      {
        path: '/notification',
        element: <pages.Notification />,
      },
      {
        path: '/notification/add',
        element: <pages.AddNotification />,
      },
      {
        path: '/notification/edit/:id',
        element: <pages.EditNotification />,
      },
    ],
  },
  {
    path: '/business-type',
    icon: <IconSettingBusinessType className={styles.iconSettingBusinessType} />,
    menu: 'setting-map',
    serialNumber: 4,
    elements: [
      {
        path: '/business-type',
        element: <pages.SettingBusinessType />,
      },
    ],
  },
  {
    path: '/registration-activation',
    icon: <IconSubMerchantActivation />,
    menu: 'setting-map',
    serialNumber: 5,
    elements: [
      {
        path: '/registration-activation',
        element: <pages.SubMerchantActivation />,
      },
      {
        path: '/registration-activation/set',
        element: <pages.FormSubMerchantActivation />,
      },
      {
        path: '/registration-activation/setting-sekaligus',
        element: <pages.UploadSubMerchantActivation />,
      },
    ],
  },
  {
    path: '/area-management',
    icon: <IconAreaManagement />,
    menu: 'setting-map',
    serialNumber: 6,
    elements: [
      {
        path: '/area-management',
        element: <pages.AreaManagement />,
      },
    ],
  },
  {
    serialNumber: 1,
    path: '/user-management/user',
    icon: <IconUser />,
    menu: 'user-management',
    elements: [
      {
        path: '/user-management/user',
        element: <pages.User />,
      },
    ],
  },
  {
    serialNumber: 2,
    path: '/user-management/role',
    icon: <IconRole />,
    menu: 'user-management',
    elements: [
      {
        path: '/user-management/role',
        element: <pages.Role />,
      },
    ],
  },
  {
    serialNumber: 3,
    path: '/user-management/permission',
    icon: <IconPermission />,
    menu: 'user-management',
    elements: [
      {
        path: '/user-management/permission',
        element: <pages.Permission />,
      },
    ],
  },
  {
    serialNumber: 4,
    path: '/user-management/audit-log',
    icon: <IconAudit />,
    menu: 'user-management',
    elements: [
      {
        path: '/user-management/audit-log',
        element: <pages.AuditLog />,
      },
    ],
  },
  {
    serialNumber: 1,
    path: '/sub-merchant/data-monitoring',
    icon: <IconLogSyns />,
    menu: 'sub-merchant-management',
    elements: [
      {
        path: '/sub-merchant/data-monitoring',
        element: <pages.SubMerchantAggregate />,
      },
    ],
  },
  {
    serialNumber: 2,
    path: '/sub-merchant/setting-data-sub-merchant/search',
    icon: <IconSettingMerchant />,
    menu: 'sub-merchant-management',
    elements: [
      {
        path: '/sub-merchant/setting-data-sub-merchant/search',
        element: <pages.SearchSubMerchant />,
      },
      {
        path: '/sub-merchant/setting-data-sub-merchant/detail/:id',
        element: <pages.SettingSubMerchant />,
      },
    ],
  },
  {
    path: '/activation-feature-map',
    icon: <IconSettingFeatureMerchantFilled />,
    menu: 'activation-feature-map',
    elements: [
      {
        path: '/activation-feature-map',
        element: <pages.MAPFeatureActivation />,
      },
      {
        path: '/activation-feature-map/bulk/:id',
        element: <pages.MAPFeatureActivationBulk />,
      },
    ]
  }
];
